__turbopack_context__.v({
  "container": "j3wkxa_container",
  "error": "j3wkxa_error",
  "error__hide": "j3wkxa_error__hide",
  "fullWidth": "j3wkxa_fullWidth",
  "label": "j3wkxa_label",
  "label__disabled": "j3wkxa_label__disabled",
  "select": "j3wkxa_select",
  "select__bordered": "j3wkxa_select__bordered",
  "select__container": "j3wkxa_select__container",
  "select__error": "j3wkxa_select__error",
  "select__left": "j3wkxa_select__left",
  "select__leftSpace": "j3wkxa_select__leftSpace",
  "select__right": "j3wkxa_select__right",
  "select__success": "j3wkxa_select__success",
  "select__warning": "j3wkxa_select__warning",
  "shimmer": "j3wkxa_shimmer",
  "statusIcon": "j3wkxa_statusIcon",
  "text-bar-sweep": "j3wkxa_text-bar-sweep",
});
